module.exports = __webpack_public_path__ + "static/media/Cripto.fe8b8ac3.gif";